import React, { Component } from 'react';
import { ActualityTemplate } from './../../Templates/index';

class Actuality extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return <ActualityTemplate />;
    }
}
export default Actuality;
